import type { CaptureContext, MonitoringProvider } from "../types";

export const stubMonitoringProvider: MonitoringProvider = {
  name: "stub",
  async capture(error, context) {
    if (typeof console === "undefined") return undefined;
    const msg = error instanceof Error ? error.message : String(error);
    console.error(
      `[monitor:stub] source=${context?.source ?? "unknown"} location=${context?.location ?? ""}: ${msg}`,
    );
    return undefined;
  },
};
